// src/utils/localStorage.js

const FAVORITES_KEY = 'floor_janitorial_favorites';
const CART_KEY = 'floor_janitorial_cart';

// Favorites
export const getFavorites = () => {
  try {
    const stored = localStorage.getItem(FAVORITES_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Error reading favorites from localStorage:', error);
    return [];
  }
};

export const saveFavorites = (favorites) => {
  try {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
  } catch (error) {
    console.error('Error saving favorites to localStorage:', error);
  }
};

export const addFavorite = (productID) => {
  const favorites = getFavorites();
  const newFavorite = {
    id: Date.now().toString() + Math.random(),
    productID: productID,
  };

  // Check if already favorited
  if (favorites.some(fav => fav.productID === productID)) {
    return favorites;
  }

  const updated = [...favorites, newFavorite];
  saveFavorites(updated);
  return updated;
};

export const removeFavorite = (productID) => {
  const favorites = getFavorites();
  const updated = favorites.filter(fav => fav.productID !== productID);
  saveFavorites(updated);
  return updated;
};

export const isFavorite = (productID) => {
  const favorites = getFavorites();
  return favorites.some(fav => fav.productID === productID);
};

export const clearFavorites = () => {
  saveFavorites([]);
  return [];
};

// Cart
export const getCart = () => {
  try {
    const stored = localStorage.getItem(CART_KEY);
    return stored ? JSON.parse(stored) : { items: [] };
  } catch (error) {
    console.error('Error reading cart from localStorage:', error);
    return { items: [] };
  }
};

export const saveCart = (cart) => {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
  } catch (error) {
    console.error('Error saving cart to localStorage:', error);
  }
};

export const clearCart = () => {
  saveCart({ items: [] });
  return { items: [] };
};
